var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"form",staticClass:"ui form"},[_c('code-editor',{attrs:{"title":_vm.$t('robot code editor'),"show_format":true},model:{value:(_vm.object.code),callback:function ($$v) {_vm.$set(_vm.object, "code", $$v)},expression:"object.code"}}),_c('div',{staticClass:"ui error message"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }